import * as angular from 'angular';

import { ReportRunResource } from '@mode/legacy/data-access-model-js';

export class RunHistoryRowController {
  run: ReportRunResource;
}

export const runHistoryRowComponent: angular.IComponentOptions = {
  bindings: {
    run: '<',
  },
  template: `
    <span class="success-icon col-xs-2">
      <i class="icon-success-check-color" ng-show="ctrl.run.state === 'succeeded'"></i>
      <i class="icon-warning-small" ng-show="ctrl.run.state === 'cancelled'"></i>
      <i class="icon-fail-color" ng-show="ctrl.run.state === 'failed'"></i>
      <i class="icon-running-gray" ng-show="ctrl.run.state === 'running' || ctrl.run.state === 'enqueued'"></i>
    </span>

    <span class="col-xs-3">
      <span ng-if="ctrl.run.completedAt" title="{{ ctrl.run.completedAt }}">{{ ctrl.run.completedAt | date : "MMM d 'at' h:mma" }}</span>
      <span ng-if="!ctrl.run.completedAt && (ctrl.run.state === 'running' || ctrl.run.state === 'enqueued')">Running</span>
    </span>

    <span class="col-xs-7">
      <mode-avatar options="ctrl.run.account.avatar" size="20"></mode-avatar>

      <span class="run-creator">
        {{ ctrl.run._resource.hasLink('report_schedule') ? 'Scheduled run' : 'Run' }} by <span class="name">{{ ctrl.run.account.name }}</span>
      </span>
    </span>
`,
  controller: RunHistoryRowController,
  controllerAs: 'ctrl',
};
